import {SmokingStageType} from './stage.js';
import {
  createStageItemTarget,
  createStageTarget,
  isEmptyStageTarget,
  temperatureToCelsius
} from './stage-target.js';

function text(value){return String(value??'').trim();}

function optionalNumber(value){
  const raw=text(value);
  if(!raw)return null;
  const number=Number(raw);
  if(!Number.isFinite(number))throw new TypeError('Numeric stage value is invalid');
  return number;
}

function optionalInteger(value){
  const raw=text(value);
  if(!raw)return null;
  const number=Number(raw);
  if(!Number.isInteger(number))throw new TypeError('plannedDurationMinutes must be a whole number');
  return number;
}

export function smokingStageInputFromForm(formData,{items=[]}={}){
  if(!formData?.get)throw new TypeError('FormData-like input is required');
  const typeKey=text(formData.get('stageType')).toLowerCase();
  const nameOverride=text(formData.get('stageName'))||null;
  if(typeKey===SmokingStageType.CUSTOM&&!nameOverride){
    throw new TypeError('Custom stage name is required');
  }

  const temperatureUnit=text(formData.get('temperatureUnit')||'C').toUpperCase();
  const targetChamberCelsius=temperatureToCelsius(optionalNumber(formData.get('targetChamber')),{unit:temperatureUnit});
  const minChamberCelsius=temperatureToCelsius(optionalNumber(formData.get('minChamber')),{unit:temperatureUnit});
  const maxChamberCelsius=temperatureToCelsius(optionalNumber(formData.get('maxChamber')),{unit:temperatureUnit});
  const plannedDurationMinutes=optionalInteger(formData.get('plannedDurationMinutes'));

  const stageTarget=createStageTarget({
    stageId:'preview',
    userId:'preview',
    targetChamberCelsius,
    minChamberCelsius,
    maxChamberCelsius,
    plannedDurationMinutes
  });

  const itemTargets=[];
  for(const item of items||[]){
    const itemId=text(item?.id);
    if(!itemId)continue;
    const raw=optionalNumber(formData.get('internalTarget:'+itemId));
    if(raw==null)continue;
    const targetInternalCelsius=temperatureToCelsius(raw,{unit:temperatureUnit});
    const target=createStageItemTarget({
      stageId:'preview',
      itemId,
      userId:'preview',
      targetInternalCelsius
    });
    itemTargets.push(Object.freeze({
      itemId,
      targetInternalCelsius:target.targetInternalCelsius
    }));
  }

  return Object.freeze({
    stage:Object.freeze({typeKey,nameOverride}),
    target:Object.freeze({
      targetChamberCelsius:stageTarget.targetChamberCelsius,
      minChamberCelsius:stageTarget.minChamberCelsius,
      maxChamberCelsius:stageTarget.maxChamberCelsius,
      plannedDurationMinutes:stageTarget.plannedDurationMinutes
    }),
    targetEmpty:isEmptyStageTarget(stageTarget),
    itemTargets:Object.freeze(itemTargets),
    temperatureUnit
  });
}
